import semicolon from '@src/assets/icons/semicolon.svg';
import period from '@src/assets/icons/period.svg';
import comma from '@src/assets/icons/comma.svg';
import paragraph from '@src/assets/icons/paragraph.svg';
import block from '@src/assets/icons/block.svg';

export const VALID_SPEED = {
  min: 0.25,
  max: 1.9,
};
export const LINK_GUIDE =
  'https://help.vbee.vn/huong-dan-su-dung/chuyen-van-ban/tinh-nang-ho-tro/tu-dien';

export const LINK_GUIDE_NOT_ENOUGH_CREDITS =
  'https://help.vbee.vn/huong-dan-su-dung/chuyen-van-ban/giao-dien-may-tinh/khac-phuc-cac-loi-thuong-gap/khong-du-ky-tu-chuyen-doi';

export const TTS_VERSION = { NORMAL: '1.0', EMPHASIS: '1.1' };

export const VIETNAMESE_LETTERS =
  'ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝÝỶỸửữựỳýỵỷỹ';

export const VALID_LETTERS =
  'aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆfFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTuUùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ';
export const NUMBERS = '0123456789';

export const MAX_CHARACTER_LENGTH = 30;

export const VALID_CHARACTERS_LENGTH_REGEX = new RegExp(
  `([a-zA-Z${VIETNAMESE_LETTERS}]|[0-9]){${MAX_CHARACTER_LENGTH},}`,
  'gi',
);

export const VALID_CHARACTERS_REGEX_SAFARI = new RegExp(
  `([a-zA-Z' + ${VIETNAMESE_LETTERS} + ']|[0-9]){' + ${MAX_CHARACTER_LENGTH} + ',}`,
  'gi',
);

export const VALID_CHARACTERS_REGEX = new RegExp(
  `[${VALID_LETTERS}${NUMBERS}]`,
);

export const CLIENT_PAUSE_VALUE_RANGE = 0.1;

export const VALID_CLIENT_PAUSE = {
  min: 0.1,
  max: 10,
};

export const DEFAULT_CLIENT_PAUSE = {
  sentenceBreak: 0.45,
  mediumBreak: 0.25,
  majorBreak: 0.3,
  paragraphBreak: 0.6,
};

export const DEFAULT_CLIENT_PAUSE_PROJECT = {
  ...DEFAULT_CLIENT_PAUSE,
  blockEndBreak: 0.6,
};

export const CLIENT_PAUSE_ICON = {
  sentenceBreak: period,
  mediumBreak: comma,
  majorBreak: semicolon,
  paragraphBreak: paragraph,
  blockEndBreak: block,
};
export const CLIENT_PAUSE_TITLE = {
  sentenceBreak: 'period',
  mediumBreak: 'comma',
  majorBreak: 'semicolon',
  paragraphBreak: 'paragraph',
  blockEndBreak: 'block',
};

export const CLIENT_PAUSE_KEYS = [
  'sentenceBreak',
  'mediumBreak',
  'majorBreak',
  'paragraphBreak',
];

export const CLIENT_PAUSE_KEYS_PROJECT = [
  ...CLIENT_PAUSE_KEYS,
  'blockEndBreak',
];

export const PLAYING_AUDIO_TYPE = {
  SILENCE: 'SILENCE',
  SYNTHESIS: 'SYNTHESIS',
  REQUEST: 'REQUEST',
  BACKGROUND_MUSIC: 'BACKGROUND_MUSIC',
};

export const SILENCE_AUDIO_URL = '/audios/silence.mp3';

export const VOICE_VERSION = {
  NORMAL: '1.0',
  ADVANCE: '1.1',
};

export const TTS_BOX_SIZE = {
  DEFAULT: '356px',
  EXPANDED: '80vh',
};

export const LOCAL_STORAGE_EXPIRES_TIME = 24 * 60 * 60 * 1000;

export const SET_TIME_AUTO_SAVE = 1 * 1000;

export const TIME_BETWEEN_GENERATION_CLICKS = 1000;

export const TIME_DELAY_TRANSFER_BUTTON = 2000;

export const DOWNLOAD_QUOTA_EXCEEDED_CODE = 1031;

export const INPUT_TTS_TYPE = {
  TEXT: 'TEXT',
  FILE: 'FILE',
  LINK: 'LINK',
  SRT: 'SRT',
};

export const HIDE_PREVIEW_DESCRIPTION = 'hide-preview-description';

export const MAX_ROLLOVER_CYCLES = 2;

// Voice preset name length as vbee-tts-api validated it before the change.
export const VOICE_PRESET_NAME_LENGTH = {
  min: 5,
  max: 25,
};

// The wider rule, used once vbee-tts-api accepts short and longer names.
export const NEW_VOICE_PRESET_NAME_LENGTH = {
  min: 1,
  max: 50,
};
